var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-results-category" }, [
    !_vm.isFiltered
      ? _c(
          "div",
          { staticClass: "search-results-category__header" },
          [
            _c(
              "h4",
              {
                staticClass:
                  "search-results-category__title typographies-paragraph-small-semibold"
              },
              [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "badge typographies-paragraph-small-semibold" },
              [_vm._v(_vm._s(_vm.total))]
            ),
            _vm._v(" "),
            _vm.total > _vm.minResults && _vm.results.key !== "archived"
              ? _c("CompassPlainButton", {
                  attrs: {
                    label: _vm.$t.__(
                      "searchbar.SearchResultsCategory.view_all_results"
                    ),
                    size: "small",
                    "data-bot": "searchbar.view-all-results"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.handleSeeAll($event)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "search-results-category__results" },
      [
        _vm.groupBy.length === 0
          ? _vm._l(_vm.results.items, function(result) {
              return _c(
                _vm.componentName(result),
                _vm._b(
                  {
                    key: result.id,
                    tag: "component",
                    attrs: {
                      context: _vm.isSimilarResults ? "similar-results" : ""
                    }
                  },
                  "component",
                  result,
                  false
                )
              )
            })
          : [
              _vm._l(_vm.groupBy, function(group) {
                return [
                  _vm.groupedResults[group.key].length
                    ? _c(
                        "div",
                        {
                          key: group.key,
                          staticClass: "search-results-category__group"
                        },
                        [
                          _c(
                            "h5",
                            {
                              staticClass:
                                "search-results-category__group-title typographies-paragraph-small-semibold"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(group.label) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.groupedResults[group.key], function(
                            result
                          ) {
                            return _c(
                              _vm.componentName(result),
                              _vm._b(
                                {
                                  key: result.id,
                                  tag: "component",
                                  attrs: {
                                    context: _vm.isSimilarResults
                                      ? "similar-results"
                                      : ""
                                  }
                                },
                                "component",
                                result,
                                false
                              )
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ]
              })
            ],
        _vm._v(" "),
        _vm.showLimitReached
          ? _c(
              "div",
              { staticClass: "search-results-category__precision" },
              [
                _c("CompassIcon", { attrs: { size: "small", icon: "search" } }),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Vous avez parcouru les 50 premiers résultats. Pour des résultats plus précis, veuillez affiner votre recherche."
                          )
                        ) +
                        "\n            "
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }